/* global Turbo */
/* eslint class-methods-use-this: "off" */
import { Controller } from '@hotwired/stimulus';
import Swal from 'sweetalert2';

export default class extends Controller {
  connect() {
    this.setupConfirmMethod();
  }

  setupConfirmMethod = () => {
    Turbo.setConfirmMethod(async (message) => {
      const result = await Swal.fire({
        text: message,
        title: 'Jesteś pewien?',
        icon: 'warning',
        showCloseButton: true,
        showCancelButton: true,
        confirmButtonText: 'Usuń',
        confirmButtonColor: '#1E88E5',
        cancelButtonText: 'Anuluj',
        cancelButtonColor: '#F3F2FD',
      });
      return result.isConfirmed;
    });
  };
}
